import React, { useState } from 'react';

import iconGeckoTerminal from '../images/webp/logo-gecko-terminal.webp';
import iconCoinGecko from '../images/webp/logo-coin-gecko.webp';
import iconDextools from '../images/webp/logo-dextools.webp';
import iconDexscreener from '../images/webp/logo-dexscreener.webp';
import iconBasescan from '../images/webp/logo-basescan.webp';
import iconTelegram from '../images/webp/logo-telegram.webp';
// import imageBananaWithBook from '../images/dancing-banana-with-book.PNG';


function DevTools() {
  const [tokenAddress, setTokenAddress] = useState('');

  const handleTokenAddressChange = (e) => {
    setTokenAddress(e.target.value);
  };

  const getDexscreenerUrl = () => {
    if (!tokenAddress) return 'https://marketplace.dexscreener.com/product/token-info/order?chainId=base&tokenAddress=';
    return `https://marketplace.dexscreener.com/product/token-info/order?chainId=base&tokenAddress=${tokenAddress}`;
  };

  return (
<>
    <div className="dev-tools-container page-content">
      <div className="section-header">
        <h1>Dev Resources</h1>
        <p>Advanced tools for token management and administration</p>
        {/* <img src={imageBananaWithBook} alt="Banana with Book" className="banana-with-book-image" /> */}
      </div>
      
      <div className="tools-grid">
        <div className="tool-card">
          <h2>Update Gecko Terminal. Free to do.</h2>
          <p>Update your token information on Gecko Terminal</p>
          <img className="tool-icon" src = {iconGeckoTerminal} alt="Gecko Terminal" />
          <a href="https://www.geckoterminal.com/update-token-info" 
            target="_blank" 
            rel="noopener noreferrer" 
          >
            <button className="button-main dev-tools-button">Go to Gecko Terminal</button>
          </a>
        </div>
        
        <div className="tool-card">
          <h2>Update on CoinGecko</h2>
          <p>Submit your token to CoinGecko listing <br/> LP and volume requirements apply. Fast track for $1000. Otherwise Free.</p>
          <img className="tool-icon" src = {iconCoinGecko} alt="CoinGecko" />

          <p style={{ 
            fontSize: '0.85rem', 
            color: '#ffb300', 
            fontStyle: 'italic',
            marginBottom: '15px'
          }}>
            
          </p>
          <a 
            href="https://www.coingecko.com/request-form/tokens/new?locale=en" 
            target="_blank" 
            rel="noopener noreferrer" 
          >
            <button className="button-main dev-tools-button">Go to CoinGecko</button>
          </a>
        </div>
        
        <div className="tool-card">
          <h3>Update Dextools</h3>
          <p>Update your token social information on Dextools. Costs around $295.</p>
          <img className="tool-icon" src = {iconDextools} alt="Dextools" />


          <a 
            href="https://www.dextools.io/marketplace/en/create-socials" 
            target="_blank" 
            rel="noopener noreferrer" 
          >
            <button className="button-main dev-tools-button">Go to Dextools</button>
          </a>
        </div>
        
        <div className="tool-card">
          <h3>Update Dexscreener</h3>
          <p>Update your token information on Dexscreener. Costs around $300.</p>
          <img className="tool-icon" src = {iconDexscreener} alt="Dexscreener" />

          <div className="token-input-container" style={{ marginBottom: '15px' }}>
            <input 
              type="text" 
              className="textbox-main"
              placeholder="Enter token contract address" 
              value={tokenAddress}
              onChange={handleTokenAddressChange}
            />
          </div>
          <a 
            href={getDexscreenerUrl()} 
            target="_blank" 
            rel="noopener noreferrer" 
          >
            <button className="button-main dev-tools-button">Go to Dexscreener</button>
          </a>
        </div>

        <div className="tool-card">
          <h3>Basescan Update</h3>
          <p>Update your token information on Basescan. <br/> Reach out to the team for assistance</p>
          <img className="tool-icon" src = {iconBasescan} alt="Basescan" />


          <a 
            href="https://basescan.org/tokenupdate/" 
            target="_blank" 
            rel="noopener noreferrer" 
          >
            <button className="button-main dev-tools-button">Go to Basescan</button>
          </a>
        </div>

        <div className="tool-card">
          <h3>Telegram Resources</h3>
          <p>Useful Telegram bots for token management and security</p>
          <img className="tool-icon" src = {iconTelegram} alt="Telegram" />

          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <a 
              href="https://t.me/SecretBaseTrendBot" 
              target="_blank" 
              rel="noopener noreferrer" 
            >
              <button className="button-main dev-tools-button">Secret Base Bot</button>
            </a>
            <a 
              href="https://t.me/safeguard" 
              target="_blank" 
              rel="noopener noreferrer" 
            >
              <button className="button-main dev-tools-button">Safeguard</button>
            </a>
            <a 
              href="https://t.me/ProtectronBot" 
              target="_blank" 
              rel="noopener noreferrer" 
            >
              <button className="button-main dev-tools-button">Protectron</button>
            </a>
          </div>
        </div>
    
      </div>
    </div>
    </>
  );
}

export default DevTools; 